// KWANKGM04280_近代化資金借入申込 完了
import React, { memo } from 'react';
import HeadingM from '../../molecules/HeadingM';
import RowCenterLongButton from '../../molecules/RowCenterLongButton';
import DefaultButton from '../../molecules/DefaultButton';
import { modernization_funds_complete_disp_type } from '../../Const';

interface Props {
  reception_cd: string;
  is_decline: boolean;
  is_change: boolean;
  is_change_modernization_funds?: boolean;
  guarantors_num: number; // 連帯債務者等の人数
  reception_id: number;
  status?: number;
  disp_type: string | null;
}

const ExaminationModernizationFundsCompleteBody: React.FC<Props> = ({
  reception_cd,
  is_decline,
  is_change,
  is_change_modernization_funds,
  guarantors_num,
  disp_type,
  reception_id,
  status,
}) => {
  // 見出しの文字列をセットする
  const setLabel = () => {
    if (is_decline) {
      // 辞退の場合
      return '借入申込辞退受付完了';
    } else if (is_change || is_change_modernization_funds) {
      // 変更完了の場合
      return '借入申込変更完了';
    }

    // 借入申込完了の場合
    return '借入申込完了';
  };

  // 本文のJSXをセットする
  const setBody = () => {
    if (is_decline) {
      // 辞退の場合
      return <p className="p-lead">借入申込辞退の受付を完了しました。</p>;
    } else if (is_change || is_change_modernization_funds) {
      // 連帯債務者等ありの場合
      if (guarantors_num > 0) {
        return (
          <p className="p-lead">
            借入申込の変更を完了しました。
            <br />
            またご登録の連帯債務者等の方に申込内容確認のためのマイページ開設招待メールを送信しました。
            <br />
            連帯債務者等がいる場合、現在は申込処理は完了していません。連帯債務者等による申込内容の確認と同意が完了すると、JAへの申込処理が完了します。
            <br />
            連帯債務者等の確認状況はマイページから確認可能です。
            <br />
            連帯債務者等の方にメールが届かない場合にはマイページから本申込み案件を開き、メールの再送信を行って下さい。
            <br />
            本お取引におけるJAからのメールについては、「no-reply@entry.ja-netloan.jp」からのみ送信されます。
          </p>
        );
      }

      // 連帯債務者なし
      return (
        <p className="p-lead">
          借入申込の変更を完了しました。
          <br />
          本お取引におけるJAからのメールについては、「no-reply@entry.ja-netloan.jp」からのみ送信されます。
        </p>
      );
    }

    if (disp_type === modernization_funds_complete_disp_type.pattern_2) {
      // パターン2で近代化資金借入申込書の入力完了時、借入申込希望書兼経営改善資金計画書がまだ入力完了となっていなかった場合に、
      return (
        <p className="p-lead">
          お客様のお申し込みを受け付けました。
          <br />
          申込番号は「{reception_cd}」です。
          <br />
          引き続き、「続けて借入申込希望書兼経営改善資金計画書を入力」ボタンを押して入力を続けて下さい。
        </p>
      );
    } else {
      // 借入申込完了の場合
      return (
        <p className="p-lead">
          お客様のお申し込みを受け付けました。
          <br />
          申込番号は「{reception_cd}」です。
        </p>
      );
    }
  };

  // メール送信通知メッセージ
  const setMailSendNotice = () => {
    // 辞退、変更完了の場合は何も表示しない
    if (is_decline || is_change || is_change_modernization_funds) {
      return;
    }

    // 連帯債務者等ありの場合
    if (guarantors_num > 0) {
      return (
        <p className="p-lead">
          【メール送信】
          <br />
          ご登録のメールアドレスに借入申込受付メールを送信しました。
          <br />
          またご登録の連帯債務者等の方に申込内容確認のためのマイページ開設招待メールを送信しました。
          <br />
          連帯債務者等がいる場合、現在は申込処理は完了していません。連帯債務者等による申込内容の確認と同意が完了すると、JAへの申込処理が完了します。
          <br />
          連帯債務者等の確認状況はマイページから確認可能です。
          <br />
          連帯債務者等の方にメールが届かない場合にはマイページから本申込み案件を開き、メールの再送信を行って下さい。
          <br />
          本お取引におけるJAからのメールについては、「no-reply@entry.ja-netloan.jp」からのみ送信されます。
        </p>
      );
    }

    // 連帯債務者等なしの場合
    return (
      <p className="p-lead">
        【メール送信】
        <br />
        ご登録のメールアドレスに借入申込受付メールを送信しました。
        <br />
        本お取引におけるJAからのメールについては、「no-reply@entry.ja-netloan.jp」からのみ送信されます。
      </p>
    );
  };

  // 近代化資金借入申込入力 画面へ遷移する
  const handleClickNextButton = () => {
    const url = new URL(
      `${location.origin}${process.env.MIX_MOCK_URL}/reception/${reception_cd}/${reception_id}/${status}`
    );
    url.searchParams.append('item_id', '32');
    sessionStorage.setItem('from_to_completeed', 'true');
    // 遷移元の商品IDを設定
    sessionStorage.setItem('from_to_item_id', '33');
    // 表示パターンを設定
    sessionStorage.setItem('disp_type', String(disp_type));
    window.location.href = url.href;
  };

  // 続けて借入申込希望書兼経営改善資金計画書を入力ボタンのJSXをセットする
  const setNextButton = () => {
    // パターン2、 借入申込変更の完了の場合は非表示
    if (disp_type === modernization_funds_complete_disp_type.pattern_2) {
      return (
        <div className="mt-5">
          <RowCenterLongButton>
            <DefaultButton
              label="続けて借入申込希望書兼経営改善資金計画書を入力"
              strong={false}
              handleClick={handleClickNextButton}
              className="a-tag-right-align"
            />
          </RowCenterLongButton>
        </div>
      );
    } else {
      return;
    }
  };

  return (
    <>
      <HeadingM label={setLabel()} />
      {setBody()}
      {setMailSendNotice()}
      {setNextButton()}
    </>
  );
};

export default memo(ExaminationModernizationFundsCompleteBody);
